import { Button } from '@pets-ui/Button/Button'
import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  stickyPaper: {
    position: 'sticky',
    zIndex: 10,
    top: 56,
  },
})

export interface AiRecommendationHeaderProps {
  onBack: () => void
  source: ReactNode
  numberOfItems: number
  orderTotal: number
}

export const AiRecommendationHeader = ({ onBack, source, numberOfItems, orderTotal }: AiRecommendationHeaderProps) => (
  <Paper display="flex" justifyContent="space-between" alignItems="center" p={4} borderTopLeftRadius={0} borderTopRightRadius={0} rootStyle={styles.stickyPaper}>
    <HStack gap={3}>
      <Button color="grey" borderColor="grey" variant="outlined" onClick={onBack}>上一頁</Button>
      <Chip borderRadius={4}>
        <HStack gap={1}>{source}</HStack>
      </Chip>
    </HStack>
    <HStack gap={3} alignItems="center" flexWrap="nowrap">
      <Text color={colors.grey600} noWrap>
        選取筆數
        {' '}
        {numberOfItems}
      </Text>
      <HStack gap={1} alignItems="center" flexWrap="nowrap">
        <Text color={colors.grey800} noWrap>採購金額</Text>
        <HStack alignItems="baseline" gap={0.25} flexWrap="nowrap">
          <Text variant="caption" color={colors.red600}>$</Text>
          <Text variant="h4" color={colors.red600}>{orderTotal.toLocaleString()}</Text>
        </HStack>
      </HStack>
    </HStack>
  </Paper>
)
